import React from "react";

export default function DiamondIcon({ className = "w-16 h-16" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M32 8L52 24L32 56L12 24L32 8Z"
                fill="#7FFF00"
                stroke="#0A1E3E"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M32 8L32 56M12 24H52"
                stroke="#0A1E3E"
                strokeWidth="1.5"
            />
            <path
                d="M18 24L32 40M46 24L32 40"
                stroke="#0A1E3E"
                strokeWidth="1"
                opacity="0.5"
            />
            <circle cx="32" cy="20" r="2" fill="#0A1E3E" />
        </svg>
    );
}
